import { useFormContext } from "react-hook-form";
import Select from "@medoma/components/Select/Select";
import type { SiteId } from "@medoma/models/sites";
import { useAreas } from "@/api/Patients";
import ErrorMessage from "@medoma/components/ErrorMessage/ErrorMessage";
import { Trans, useLingui } from "@lingui/react/macro";

export type AreaSelectFields = {
  areaId: string;
};

const AreaSelect = ({ siteId }: { siteId: SiteId }) => {
  const { t } = useLingui();
  const {
    register,
    formState: { errors },
  } = useFormContext<AreaSelectFields>();

  const {
    data: areas,
    isPending: isPendingAreas,
    isError: isErrorAreas,
  } = useAreas(siteId);

  if (isErrorAreas) {
    return (
      <ErrorMessage
        message={t`Kunde inte hämta områden. Försök igen om en liten stund. Kontakta support om problemet kvarstår.`}
      />
    );
  }

  if (isPendingAreas) {
    return (
      <Select label={t`Område`} name="areaId">
        <option>{t`Hämtar områden`}...</option>
      </Select>
    );
  }

  if (areas.length === 0) {
    return (
      <ErrorMessage
        message={t`Inga områden hittades. Försök igen om en liten stund. Kontakta support om problemet kvarstår.`}
      />
    );
  }

  return (
    <Select
      label={t`Område`}
      {...register("areaId")}
      errorMessage={errors.areaId?.message}
    >
      <option value="">
        <Trans>Inget</Trans>
      </option>
      {areas.map((area) => (
        <option value={area.id.toString()} key={area.id}>
          {area.displayName}
        </option>
      ))}
    </Select>
  );
};

export default AreaSelect;
